import {
  CurrencyDto,
  ExchangeRateToIrrResponse,
  PricingAdjustmentResponse,
  ShoppingCartItemType,
} from '../../models/shopping-cart.model';
import { BundleServiceProviderItemResponse } from '../../models/gitcard.model';

export interface CartItemCalculationView {
  serviceProviderItemId: string;
  requestAmount: string;
  fromCurrencyName: string | null;
  toCurrencyName: string | null;
  fromPrecision: number;
  toPrecision: number;
  buyRate: string | null;
  conversionAmount: string;
  commissionCalculationType: number | null;
  commissionValue: string;
  commissionPercent: string;
  commissionAmount: string;
  discountPercent: string;
  discountAmount: string;
  finalPaymentAmount: string;
  originalAmount: string | null;
  showCommission: boolean;
}

export interface CartBundleItemView {
  item: BundleServiceProviderItemResponse;
  calculation: CartItemCalculationView | null;
  showCommission: boolean;
}

export interface CartItem {
  shoppingCartItemId: string;
  itemType: ShoppingCartItemType;
  giftCard: GiftCardCartItem | null;
  bundle: BundleCartItem | null;
  calculation?: CartItemCalculationView | null;
  bundleItems?: CartBundleItemView[] | null;
}

export interface GiftCardCartItem {
  serviceProviderItemId: string;
  providerEnglishName: string | null;
  providerLogoUrl: string | null;
  serviceName: string | null;
  currency: CurrencyDto;
  amount: string;
  quantity: number;
  exchangeRateToIrr: ExchangeRateToIrrResponse;
  commission: PricingAdjustmentResponse;
  discount: PricingAdjustmentResponse;
}

export interface BundleCartItem {
  bundleId: string;
  bundleName: string | null;
  logoUrl: string | null;
  serviceNames: string[] | null;
  giftCardCount: number;
  quantity: number;
  discount: PricingAdjustmentResponse;
  giftCards: BundleGiftCardCartItem[];
}

export interface BundleGiftCardCartItem {
  serviceProviderItemId: string;
  providerEnglishName: string | null;
  providerLogoUrl: string | null;
  serviceName: string | null;
  currency: CurrencyDto;
  amount: string;
  exchangeRateToIrr: ExchangeRateToIrrResponse;
  commission: PricingAdjustmentResponse;
}

export function giftCardDisplayName(
  gc:
    | Pick<GiftCardCartItem, 'serviceName' | 'providerEnglishName'>
    | null
    | undefined,
): string {
  const service = gc?.serviceName?.trim() ?? '';
  const provider = gc?.providerEnglishName?.trim() ?? '';
  if (service && service !== 'گیفت کارت') return service;
  return provider || service;
}

export function cartItemDisplayName(item: CartItem): string {
  if (item.giftCard) return giftCardDisplayName(item.giftCard);
  return item.bundle?.bundleName?.trim() ?? '';
}

export interface CartApiResponse {
  shoppingCartId: string;
  totalItemCount: number;
  cartExpiresAt: string | null;
  token: string;
  expireInSecond: number;
  expireAt: string;
  rialCurrencyName: string;
  rialTotals: Map<string, string>;
  showCommission: boolean;
  items: CartItem[];
}
